import { createAPI } from '@common'

export default {
  // 启用模板
  postMamOpenTemplate: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0ufnqmbuf0pqfo', 'POST', config),
  // 禁用模板
  postMamForbiddenTemplate: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0ufnqmbuf0gpscjeefo', 'POST', config),
  // 修改阿里云对应的模板id
  postMamAliyunId: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0ufnqmbuf0bmjzvo0je', 'POST', config)
}

 
